import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f47358e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "base-title-button"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "top_panel_close", -1))
const _hoisted_3 = {
  key: 1,
  class: "base-title-button"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "bottom_panel_close", -1))
const _hoisted_5 = {
  key: 2,
  class: "base-title-button"
}
const _hoisted_6 = { class: "base-title-button" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fw-light" }, "add_circle", -1))
const _hoisted_8 = {
  key: 0,
  class: "filters"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "table table-hover align-top mt-4" }
const _hoisted_12 = { class: "border-dark border-bottom pb-2" }
const _hoisted_13 = { class: "border-dark border-bottom" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_content_page_library_available = _resolveComponent("base-content-page-library-available")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_AlertError = _resolveComponent("AlertError")!
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_placeholder_table = _resolveComponent("base-placeholder-table")!
  const _component_CpsOverviewItem = _resolveComponent("CpsOverviewItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_base_title, {
      title: this.title,
      "help-text": this.$t('descriptions.contentPagesOverview'),
      "back-route": this.isLibrary ? {name: 'libraries-available', params: {cb_structure: this.LibraryStructureTypeEnum.CONTENT_PAGE}} : null,
      "is-library": this.isLibrary,
      mb: 3,
      "show-refresh-button": "",
      onRefresh: this.reloadContent
    }, {
      buttons: _withCtx(() => [
        (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_HEADER_STACK') && !this.isLibrary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_router_link, {
                to: {name: 'headers'},
                class: "btn btn-hover icon-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_2,
                  _createTextVNode(_toDisplayString(_ctx.$t('header')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.AbilityContext.isAuthorizedForFeature('CUSTOM_FOOTER_STACK') && !this.isLibrary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: {name: 'footers'},
                class: "btn btn-hover icon-link"
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _createTextVNode(_toDisplayString(_ctx.$t('footer')), 1)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (this.isReady && this.isAuthorizedForCopyLibrary && this.hasContentLib)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_base_content_page_library_available, {
                "content-block-libs-for-type": this.contentBlockLibsForType,
                "lib-code": this.libType,
                title: `${_ctx.$t('websiteContent')} ${_ctx.$t('library').toLowerCase()}`,
                onCopy: this.copyLibCp
              }, null, 8, ["content-block-libs-for-type", "lib-code", "title", "onCopy"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: (_ctx.isLibrary)
          ? {name: 'libraries-new-content-page', params: {page_type_code: this.libPageTypeCode, lib_code: this.libCode}}
          : {name: 'new-content-page'},
            class: "btn btn-hover icon-link"
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _: 1
    }, 8, ["title", "help-text", "back-route", "is-library", "onRefresh"]),
    _createVNode(_component_AlertError, {
      exceptions: this.exceptions
    }, null, 8, ["exceptions"]),
    _createVNode(_component_AlertError2, {
      error: this.contentPageUI.getError()
    }, null, 8, ["error"]),
    (this.isReady)
      ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
          _createVNode(_component_dp_form, {
            as: "form",
            onSubmit: _ctx.reloadContent,
            novalidate: ""
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  (!this.isLibrary)
                    ? (_openBlock(), _createBlock(_component_input_select, {
                        key: 0,
                        modelValue: this.contentPageCriteria.filter_type_code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.contentPageCriteria.filter_type_code) = $event)),
                        class: "filter-page-type",
                        label: _ctx.$t('type'),
                        name: "filterPageTypeCode",
                        selectText: _ctx.$t('selectText'),
                        options: this.pageTypeEnums,
                        errors: errors
                      }, null, 8, ["modelValue", "label", "selectText", "options", "errors"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("table", _hoisted_11, [
      _createElementVNode("thead", _hoisted_12, [
        _createElementVNode("tr", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('name')), 1),
          _hoisted_15,
          (!this.isLibrary)
            ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(_ctx.$t('type')), 1))
            : _createCommentVNode("", true),
          _hoisted_17,
          _createElementVNode("th", null, _toDisplayString(_ctx.$t('created')), 1),
          _hoisted_18
        ])
      ]),
      _createElementVNode("tbody", null, [
        (!this.isReady)
          ? (_openBlock(), _createBlock(_component_base_placeholder_table, {
              key: 0,
              "n-cols": this.isLibrary ? 6 : 7
            }, null, 8, ["n-cols"]))
          : (!this.hasContentPages)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                _createElementVNode("td", {
                  colspan: this.isLibrary ? 6 : 7,
                  class: "fw-bold small text-uppercase text-muted"
                }, _toDisplayString(_ctx.$t('noResults')), 9, _hoisted_20)
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(this.fullContentPages, (fullContentPage) => {
                return (_openBlock(), _createBlock(_component_CpsOverviewItem, {
                  key: fullContentPage.id,
                  "full-content-page": fullContentPage,
                  type: this.libCode,
                  "can-move": !!this.contentPageCriteria.filter_type_code,
                  onCopy: this.copyContent,
                  onDelete: this.deleteContent,
                  onMove: this.moveContent,
                  onUpdateIsPublishedOnHome: this.updateIsPublishedOnHome,
                  onUpdateStatus: this.updateStatus,
                  onUpdateType: this.updateType
                }, null, 8, ["full-content-page", "type", "can-move", "onCopy", "onDelete", "onMove", "onUpdateIsPublishedOnHome", "onUpdateStatus", "onUpdateType"]))
              }), 128))
      ])
    ])
  ], 64))
}